export const frameCostPerHeadshot = 50;

export const tool = "ai-headshot-generator";
